(function () {
  // ---------------------------------------------------------------------------
  // SHARED Q&A LIBRARY — reusable items referenced by key in FAQ_DATA below
  // ---------------------------------------------------------------------------
  const FAQ_ITEMS = {
    // Installation & Setup
    doorCompatibility: {
      q: "Will the lock fit my door?",
      a: "The PRISM locks are compatible with most standard HDB and condominium doors. Arrange for a complimentary virtual survey with our lock experts <a href='https://api.whatsapp.com/send/?phone=6560282215&text=I%27m+interested+in+the+digital+door+lock&type=phone_number&app_absent=0' style='font-weight: 600;'>HERE</a> or refer to our compatibility guide on our website before installation.",
    },
    installationIncluded: {
      q: "Is installation included?",
      a: "Installation and app pairing support is included with every purchase, ensuring proper setup by trained professionals.",
    },
    batteryRunsOut: {
      q: "What happens if the battery runs out?",
      a: "You will receive low battery alerts in advance. If the battery is fully depleted, you can still unlock the door using the physical key or jumpstart the lock using a powerbank.",
    },

    // Product Features
    ultraUpgrade: {
      q: "Is it worth upgrading to an Ultra model?",
      a: "Ultra models offer advanced features such as facial recognition and palm print recognition for enhanced security. They also provide two-way video calling to communicate easily with visitors, and playback functionality that captures images when loitering is detected.",
    },
    duoSync: {
      q: "What is DuoSync?",
      a: "DuoSync technology allows compatible gate and door locks to unlock together for a smoother entry experience. Both Gate-to-Door and Door-to-Gate DuoSync are supported.",
    },
    sentryDifference: {
      q: "What makes the PRISM Sentry 2026 Series different from other digital locks?",
      a: "The Sentry 2026 Series is designed to work with both regular and privacy gates. The privacy gate version features a distinctive front panel keyhole for emergency access, providing extra peace of mind.",
    },
    spectreDifference: {
      q: "What makes the PRISM Spectre Series different from other digital locks?",
      a: "The Spectre Series is Singapore's #1 slimmest lock featuring a handleless design for a sleek profile. The back panel handle allows for intuitive buttonless access. It also features a mechanical child-lock that locks your door with added security.",
    },
    doorLockDifference: {
      q: "How do the Sentinel, Spectre, and Sentra door locks differ?",
      a: "Sentinel and Spectre are mortise locks fitted into the door, offering fire-rated protection and high security, compatible with doors 40-80mm thick. Sentra is a rim lock mounted on the door surface without cutting into it, which allows installation on doors of varying thickness but does not provide fire-rated protection. All three offer multiple access methods, but their installation style and door compatibility differ."
    },

    // Security & Support
    lockSecurity: {
      q: "Are the PRISM smart locks secure?",
      a: "Yes. Our locks are encrypted to the AES-128 bit standard (used by most banks in Singapore) and includes enhanced security features such as anti-peep passcode entry and loitering alarms.",
    },
    warranty: {
      q: "What warranty is included?",
      a: "All locks are covered by a 1+2 year warranty. The first year is fully comprehensive including parts and labour. The next 2 years, all parts are covered subject to a $50 labour charge per visit. Fully comprehensive 3 and 5 year extended warranty plans are also available.",
    },
  };

  // Shorthand helper — resolves an array of FAQ_ITEMS keys into full { q, a } objects
  function items() {
    return Array.prototype.slice.call(arguments).map(function (key) {
      return FAQ_ITEMS[key];
    });
  }

  // ---------------------------------------------------------------------------
  // FAQ DATA — keyed by Shopify product handle
  // Order of Q&As rendered: installation → features → security
  // Omit a tab key to exclude those Q&As entirely.
  // ---------------------------------------------------------------------------
  const FAQ_DATA = {
    "prism-sentinel-bundle-2026": {
      installation: items("doorLockDifference", "doorCompatibility", "installationIncluded"),
      features: items("duoSync", "ultraUpgrade"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-spectre-bundle-2026": {
      installation: items("doorLockDifference", "doorCompatibility", "installationIncluded"),
      features: items("duoSync", "ultraUpgrade", "spectreDifference"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-sentra-bundle-2026": {
      installation: items("doorLockDifference", "doorCompatibility", "installationIncluded"),
      features: items("duoSync", "ultraUpgrade"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-door-gate-lock-bundles": {
      installation: items("doorCompatibility", "installationIncluded"),
      features: items("duoSync"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-sentinel-series-2026": {
      installation: items(
        "doorLockDifference",
        "doorCompatibility",
        "installationIncluded",
        "batteryRunsOut",
      ),
      features: items("ultraUpgrade"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-sentry-series-2026": {
      installation: items(
        "doorCompatibility",
        "installationIncluded",
        "batteryRunsOut",
      ),
      features: items("ultraUpgrade", "sentryDifference"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-spectre-series-2026": {
      installation: items(
        "doorLockDifference",
        "doorCompatibility",
        "installationIncluded",
        "batteryRunsOut",
      ),
      features: items("ultraUpgrade", "spectreDifference"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-sentra-door-lock-2026": {
      installation: items(
        "doorLockDifference",
        "doorCompatibility",
        "installationIncluded",
        "batteryRunsOut",
      ),
      features: items("ultraUpgrade"),
      security: items("lockSecurity", "warranty"),
    },

    "prism-sentinel-series": {
      installation: items(
        "doorCompatibility",
        "installationIncluded",
        "batteryRunsOut",
      ),
      security: items("lockSecurity", "warranty"),
    },

    "prism-sentry-series": {
      installation: items(
        "doorCompatibility",
        "installationIncluded",
        "batteryRunsOut",
      ),
      security: items("lockSecurity", "warranty"),
    },

    // To add a new product:
    // "product-handle": {
    //   installation: items("doorCompatibility", "installationIncluded"),
    //   features: [{ q: "Unique question?", a: "Unique answer." }],
    //   security: items("lockSecurity", "warranty"),
    // },
  };

  // ---------------------------------------------------------------------------
  // Tab order — defines the sequence Q&As are rendered in (no tabs shown)
  // ---------------------------------------------------------------------------
  const TAB_ORDER = ["installation", "features", "security"];

  // ---------------------------------------------------------------------------
  // Resolve product handle from current URL
  // ---------------------------------------------------------------------------
  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  var handle = getProductHandle();
  var data = FAQ_DATA[handle];

  if (!data) return;

  // Flatten all Q&As in order
  var allItems = TAB_ORDER.reduce(function (acc, key) {
    var group = data[key];
    if (group && group.length) acc = acc.concat(group);
    return acc;
  }, []);

  if (!allItems.length) return;

  // ---------------------------------------------------------------------------
  // Styles
  // ---------------------------------------------------------------------------
  var style = document.createElement("style");
  style.textContent = `
    .faq-section {
      max-width: 1200px;
      margin: 60px auto;
      padding: 0 24px;
      color: #111;
    }
    .faq-title {
      text-align: center;
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 36px;
      letter-spacing: -0.01em;
    }
    .faq-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .faq-item {
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      overflow: hidden;
    }
    .faq-question {
      width: 100%;
      background: none;
      border: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      cursor: pointer;
      font-size: 14px;
      color: #111;
      text-align: left;
      transition: background 0.15s;
    }
    .faq-question:hover { background: #f5f5f5; }
    .faq-item.open {
      background: #f5f5f5;
      box-shadow: 4px 4px 10px 0px #00000040;
    }
    .faq-item.open .faq-question { background: #f5f5f5; }
    .faq-icon {
      font-size: 1.3rem;
      color: #aaa;
      line-height: 1;
      flex-shrink: 0;
      margin-left: 16px;
    }
    .faq-answer {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease, padding 0.3s ease;
      font-size: 12px;
      color: #444;
      line-height: 1.6;
      padding: 0 24px;
    }
    .faq-item.open .faq-answer {
      max-height: 300px;
      padding: 0 24px 20px;
    }

    @media (min-width: 1024px) {
      .faq-title    { font-size: 30px; }
      .faq-question { font-size: 16px; }
      .faq-answer   { font-size: 14px; }
    }
  `;
  document.head.appendChild(style);

  // ---------------------------------------------------------------------------
  // Build HTML
  // ---------------------------------------------------------------------------
  var itemsHtml = allItems
    .map(function (item) {
      return (
        '<div class="faq-item">' +
        '<button class="faq-question">' +
        item.q +
        '<span class="faq-icon">+</span></button>' +
        '<div class="faq-answer">' +
        item.a +
        "</div>" +
        "</div>"
      );
    })
    .join("");

  var html =
    '<section class="faq-section">' +
    '<h2 class="faq-title">Frequently Asked Questions</h2>' +
    '<div class="faq-list">' +
    itemsHtml +
    "</div>" +
    "</section>";

  var wrapper = document.createElement("div");
  wrapper.innerHTML = html;

  function injectBtn() {
    const button = document.createElement("a");
    button.href = "javascript:void(0)";
    button.classList.add("btn", "spec-button");
    button.textContent = "FAQs";
    button.addEventListener("click", function () {
    const y =
        wrapper.getBoundingClientRect().top +
        window.scrollY -
        180; // adjust until perfect

    window.scrollTo({
        top: y,
        behavior: "smooth"
    });
});
    document.querySelector("#Specs")?.before(button);
  }

  // ---------------------------------------------------------------------------
  // Inject before the Shopify section containing #judgeme_product_reviews
  // ---------------------------------------------------------------------------
  function inject() {
    var reviewsEl = document.getElementById("judgeme_product_reviews");
    if (!reviewsEl) return false;

    var shopifySection = reviewsEl.closest(".shopify-section");
    if (!shopifySection) return false;

    shopifySection.parentNode.insertBefore(wrapper, shopifySection);
    injectBtn();
    return true;
  }

  if (!inject()) {
    var observer = new MutationObserver(function () {
      if (inject()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ---------------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------------
  wrapper.querySelectorAll(".faq-question").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest(".faq-item");
      var isOpen = item.classList.contains("open");
      if (!isOpen) {
        item.classList.add("open");
        btn.querySelector(".faq-icon").textContent = "−";
      } else {
        item.classList.remove("open");
        btn.querySelector(".faq-icon").textContent = "+";
      }
    });
  });
})();
